
@let cu = customer();

<div class="filter-container">

  <!-- Filter -->
  <div class="filter-header offcanvas-header">
    <h4 class="offcanvas-title">Filter</h4>
    @if (clientIsMobile() == false) {
      <button type="button" class="btn-close" aria-label="Close" (click)="closeCanvas()"></button>
    }
  </div>

  <div class="offcanvas-body">
    <div class="selections-row">
      <div class="filter-selections">
        @if (! hasSelections()) {
          <small class="info">Wähle zuerst einen Filter aus.</small>
        }

        @for (selections of viewSelections() | keyvalue; track selections) {
          @for (optionId of selections.value.selections; track optionId) {
            <gea-shop-filter-selection
              [selection]="getOption(selections.value.attributeCode, optionId)"
              (onRemove)="removeSelection($event, selections.value.attributeCode)"
              class="selection-container"
            ></gea-shop-filter-selection>
          }
        }
      </div>
    </div>

    <div class="filter-options">
      <!-- Meine Größen-->
      <div class="preferences">
        <h6>Meine Größen</h6>

        <div class="preferences-body">
          @if (! cu) {
            <small class="info">
              Du kannst deine Auswahl speichern, indem du dich anmeldest, oder dir ein Kundenkonto erstellst.
            </small>
          }
          @if (cu && ! getPossiblePreferences()) {
            <small class="info" >Du kannst Größen auswählen, deine Auswahl speichern und jederzeit anwenden.</small>
            <button type="button" class="btn btn-filter active" (click)="selectPreferences()">Auswählen</button>
          }

          @if (cu && getPossiblePreferences()) {
            <a role="button" class="text-decoration-underline" (click)="selectPreferences()">{{ getPossiblePreferences() }} <gea-svg-pencil /></a>
            <div class="form-check form-switch d-inline-block">
              <input [checked]="isPreferenceFilterToggled()" class="form-check-input" type="checkbox" role="switch" (click)="togglePreferenceFilter()">
            </div>
          }
        </div>
      </div>

      <div ngbAccordion #filterContainer="ngbAccordion" [closeOthers]="false">
        <!-- product attributes -->
        @for (attribute of productAttributes(); track attribute) {
          <div ngbAccordionItem [collapsed]="! productViewAttributes().getCount(attribute)">
            <div ngbAccordionHeader>
              <button ngbAccordionButton>
                <span>{{ attribute.title }}</span>
                &nbsp;
                @if (productViewAttributes().getCount(attribute)) {
                  <span>( {{ productViewAttributes().getCount(attribute) }} )</span>
                }
              </button>
            </div>
            <div ngbAccordionCollapse id="{{'attr_' + attribute.code}}">
              <div ngbAccordionBody>
                <ng-template>
                  @if (attribute.code != 'color_group') {
                    <gea-shop-tile
                      [attribute]="attribute"
                      [(viewSelections)]="viewSelections"
                    ></gea-shop-tile>
                  } @else {
                    <gea-shop-swatch
                      [attribute]="attribute"
                      [(viewSelections)]="viewSelections"
                    ></gea-shop-swatch>
                  }
                </ng-template>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="bottom-bar">
    <div class="filter-button">
      <button type="button" class="btn btn-primary" (click)="saveFilter()">Filter anwenden</button>
      <button type="button" class="btn btn-secondary" (click)="resetFilter()">Filter zurücksetzen</button>
    </div>
  </div>

</div>
